import { useAuth } from 'react-oidc-context';
import { useUserContext } from '../UserContext';
import { DefaultLoadingScreen } from '../components/ApiLoadingGuard';
import LiveView from '../components/LiveView/LiveView';
import DemoLiveView from '../components/LiveView/DemoLiveView';
import { Box } from '@mui/material';
import { RESPONSIVE_DRAWER_HEIGHT } from '../Constants';
import { MenuBar } from '../components/MenuBar';
import { isDemoLive } from '../utils/navigationUtils';

export default function LiveViewPage() {
  const { data: user } = useUserContext();
  const token = useAuth().user?.access_token;

  if (!user || !user.preferredJobsite?.id || !token) return <DefaultLoadingScreen />;

  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        width: '100%',
        height: `calc(100vh - ${RESPONSIVE_DRAWER_HEIGHT}px)`,
        overflow: 'hidden',
        top: RESPONSIVE_DRAWER_HEIGHT,
        padding: 2,
        boxSizing: 'border-box',
        backgroundColor: '#eeeeee',
      }}
    >
      <Box sx={{ height: RESPONSIVE_DRAWER_HEIGHT }}>
        <MenuBar />
      </Box>
      {isDemoLive(user.preferredJobsite) ? (
        <DemoLiveView organisationId={user.organisation.id} jobsiteId={user.preferredJobsite.id} />
      ) : (
        <LiveView token={token} organisationId={user.organisation.id} jobsiteId={user.preferredJobsite.id} />
      )}
    </Box>
  );
}
